<template>
  <div ref="chart" class="chart" />
</template>

<script>
  import Anychart from 'anychart';

  const options = {
    'chart': {
      'title': 'График 8 (смешанный)',
      'animation': true,
      'tooltip': { 'displayMode': 'union' },
      'interactivity': { 'hoverMode': 'by-x' },
      'legend': {
        'enabled': true,
        'vAlign': 'bottom',
        'hAlign': 'start',
        'position': 'bottom',
        "positionMode": "outside",
        "padding": {
          "left": 10,
          "top": 10,
          "bottom": 0,
          "right": 10
        }
      },
      'series': [{
        'seriesType': 'column',
        'name': 'Сумма по полю Масса разгруженная',
        'data': [
          { 'x': '3', 'value': 13278.70 },
          { 'x': '4', 'value': 4592.25 },
          { 'x': '7', 'value': 58628.84 },
          { 'x': '8', 'value': 40382.67 },
          { 'x': '9', 'value': 37233.39 },
          { 'x': '10', 'value': 80850.45 },
          { 'x': '11', 'value': 87097.42 },
          { 'x': '12', 'value': 54561.42 }
        ]
      }, {
        'seriesType': 'column',
        'name': 'Сумма по полю Дистанция, км',
        'data': [
          { 'x': '3', 'value': 121048.18 },
          { 'x': '4', 'value': 60999.34 },
          { 'x': '7', 'value': 335371.28 },
          { 'x': '8', 'value': 368870.82 },
          { 'x': '9', 'value': 328795.98 },
          { 'x': '10', 'value': 814558.17 },
          { 'x': '11', 'value': 957675.89 },
          { 'x': '12', 'value': 370012.72 }
        ]
      }, {
        'seriesType': 'column',
        'name': 'Сумма по полю Тонна/км',
        'data': [
          { 'x': '3', 'value': 3.12 },
          { 'x': '4', 'value': 2.91 },
          { 'x': '7', 'value': 4.82 },
          { 'x': '8', 'value': 3.52 },
          { 'x': '9', 'value': 3.65 },
          { 'x': '10', 'value': 4.07 },
          { 'x': '11', 'value': 3.93 },
          { 'x': '12', 'value': 4.22 }
        ]
      }, {
        'seriesType': 'spline',
        'name': 'Сумма по полю ЦЕНА_ДЛЯ_ГП_разгр_За_Тонну',
        'normal': { 'stroke': { 'color': '#ef6c00', 'thickness': 2.5 } },
        'data': [
          { 'x': '3', 'value': 378220.00 },
          { 'x': '4', 'value': 177565.00 },
          { 'x': '7', 'value': 1617305.00 },
          { 'x': '8', 'value': 1298080.00 },
          { 'x': '9', 'value': 1199610.00 },
          { 'x': '10', 'value': 3311423.00 },
          { 'x': '11', 'value': 3765732.00 },
          { 'x': '12', 'value': 1562425.00 }
        ]
      }],
      'type': 'column'
    }
  };

  export default {
    data() {
      return {
        chart: null,
        options
      }
    },

    mounted() {
      if (!this.chart && this.options) {
        this.init();
      }
    },

    methods: {
      init() {
        if (!this.chart && this.options) {
          let _Anychart = this.Anychart || Anychart;
          this.chart = new _Anychart.fromJson(this.options);
          this.chart.container(this.$refs.chart).draw();
        }
      }
    },

    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
    }
  }
</script>

<style scoped>
  .chart {
    width: 1200px;
    height: 600px;
  }
</style>